if (!customElements.get('facet-filters-form')) {
  customElements.define(
    'facet-filters-form',
    class FacetFiltersForm extends HTMLElement {
      constructor() {
        super();
        this.forms = this.querySelectorAll('form');
        this.forms.forEach((form) => {
          form.addEventListener('input', this.onFormInput.bind(this));
          form.addEventListener('change', this.onFormChange.bind(this));
          form.addEventListener('submit', this.onFormSubmit.bind(this));
        });
      }

      onFormInput(event) {
        if (!this.isPriceInput(event.target)) return;
        clearTimeout(this.priceTimer);
        this.priceTimer = setTimeout(() => this.submitForm(event.target.form), 700);
      }

      onFormChange(event) {
        if (this.isPriceInput(event.target)) return;
        this.submitForm(event.target.form);
      }

      onFormSubmit(event) {
        event.preventDefault();
        this.submitForm(event.target);
      }

      isPriceInput(input) {
        return input?.type === 'number' || input?.classList?.contains('field__input');
      }

      submitForm(form) {
        if (!form) return;

        const formData = new FormData(form);
        const params = new URLSearchParams();

        formData.forEach((value, key) => {
          if (value !== '') params.append(key, value);
        });

        window.location.href = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}`;
      }
    }
  );
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', class FacetRemove extends HTMLElement {});
}
